
import * as React from "react";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { useWebPortalApiClient } from "../../misc/api/WebPortalTokenClient";
import { ODataParams, Query } from "../../Components/Query";
import DocumentTitle from "../../misc/components/DocumentTitle";
import { SubjectsTable } from "./SubjectsTable";

export const SubjectsListScreen = () => {
    const { study } = useCurrentStudyConfigurationContext();
    const client = useWebPortalApiClient();

    const handleRefresh = async (params: ODataParams) => {

        let filter = params.filter ? `(${params.filter}) and ` : '';
        filter += `site/studyId eq ${study.id}`;

        return await client.client.getSubjects(undefined, filter, params.orderby, 'site($select=id,number,studyId)', params.top, params.skip, undefined, true);
    }

    return (
        <DocumentTitle title="Subjects List | Vitalograph Web Portal">
            <Query onRefresh={handleRefresh} initialOrdering={[{ field: "number", condition: "asc"}]}>
                <SubjectsTable />
            </Query>
        </DocumentTitle>
    );
}